import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PortailOrderComponent } from './@clu-fe/apps/m-orderportail/m-op-app.component';
import { AppUpdateAppComponent } from './pages/update-app/update-app.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./@auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'cluadmin',
    loadChildren: () => import('./@clu-be/clu-be.module').then(m => m.CluBEModule),
  },
  {
      path: 'portail',
      loadChildren: () => import('./@clu-fe/apps/m-orderportail/order-portail.module').then(m => m.OrderPortailModule),
  },
  {
    path: '',
    loadChildren: () => import('./@clu-fe/clu-fe.module').then(m => m.CluFEModule),
  },
  {
    path: 'update-app',
    component: AppUpdateAppComponent,
  },

];

// { preloadingStrategy: PreloadAllModules, useHash: true, onSameUrlNavigation: 'reload' }
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
